import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { localizationUtils } from "@flights/web-api-utils-universal";
import GlobalProvider from "../GlobalContext/GlobalProvider.js";
import LocaleProvider from "../locale/LocaleProvider.js";
import { TrackerProvider } from "../TrackerContext/TrackerProvider.js";
import OrchestratorProvider from "../OrchestratorContext/OrchestratorProvider.js";
import { MultiProductWrapper } from "../../components/elements/MultiProducts/MultiProductWrapper.js";
import RemoteComponentExperiment from "../RemoteCompoent/RemoteComponentExperiment.js";
import I18nProviderRenderer from "./I18nProviderRenderer.js";
export default function ClientProviders({ appComponent, prefix, globalContext, i18nState, store, rcContext, dateLocale }) {
    const AppComponent = appComponent;
    const language = globalContext.lang;
    return (React.createElement(BrowserRouter, { basename: `/${prefix}` },
        React.createElement(LocaleProvider, { locale: dateLocale, isRTL: language ? localizationUtils.isRTL(language) : false },
            React.createElement(GlobalProvider, { ...globalContext },
                React.createElement(TrackerProvider, null,
                    React.createElement(I18nProviderRenderer, { i18nState: i18nState },
                        React.createElement(ReduxProvider, { store: store, identityFunctionCheck: "never" },
                            React.createElement(HelmetProvider, null,
                                React.createElement(OrchestratorProvider, null,
                                    React.createElement(MultiProductWrapper, null,
                                        React.createElement(RemoteComponentExperiment, { value: rcContext },
                                            React.createElement(AppComponent, null))))))))))));
}
